'use client';

import { ConfirmActionDialog } from '@/components/ui/confirm-action-dialog';

interface DeleteTeamDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => Promise<void>;
  teamNumber: number;
}

export function DeleteTeamDialog({
  isOpen,
  onClose,
  onDelete,
  teamNumber,
}: DeleteTeamDialogProps) {
  return (
    <ConfirmActionDialog
      isOpen={isOpen}
      title="Eliminar equipo"
      description={`¿Estás seguro de que deseas eliminar el Equipo #${teamNumber}? Esta acción no se puede deshacer.`}
      warning="El equipo será eliminado permanentemente del torneo. Los jugadores recibirán una notificación sobre la eliminación."
      confirmLabel="Eliminar equipo"
      pendingLabel="Eliminando..."
      variant="destructive"
      onClose={onClose}
      onConfirm={onDelete}
    />
  );
}
